var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12021 1.89987H24.8837C25.0893 1.89994 25.2905 1.9598 25.4627 2.07216C25.6349 2.18453 25.7706 2.34455 25.8535 2.53273C25.9364 2.7209 25.9627 2.92912 25.9293 3.132C25.8959 3.33488 25.8042 3.52367 25.6655 3.67537L16.9602 13.2551C16.779 13.449 16.6794 13.7052 16.682 13.9706V21.4701C16.6836 21.6463 16.6407 21.82 16.5573 21.9752C16.4739 22.1304 16.3527 22.262 16.205 22.3579L11.965 25.1801C11.8059 25.2849 11.6216 25.3449 11.4313 25.3537C11.2411 25.3626 11.052 25.3201 10.8839 25.2306C10.7158 25.1411 10.5748 25.008 10.476 24.8452C10.3771 24.6825 10.3239 24.4961 10.322 24.3056V13.9706C10.3245 13.7052 10.2249 13.449 10.0437 13.2551L1.33846 3.67537C1.19967 3.52367 1.108 3.33488 1.07462 3.132C1.04123 2.92912 1.06757 2.7209 1.15042 2.53273C1.23327 2.34455 1.36907 2.18453 1.54126 2.07216C1.71345 1.9598 1.9146 1.89994 2.12021 1.89987V1.89987Z",
    stroke: "#DDDEE4",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d3be6561f747c3d1c60fb363811ead27.svg";
export { ForwardRef as ReactComponent };